import { ColumnDTO, ExportConfigDTO, exportFile, FilterDTO, useApiService } from "medere-ui-framework";

const toLocalISOString = (date: Date): string => {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

export function useHospitalizationService() {
  const { api } = useApiService();
  const baseEndpoint = "/api/secured/hospitalization";

  async function getValuationOfPatient(offset: number, pageSize: number, params: any) {
    const response = await api.get(`${baseEndpoint}/getValuationOfPatient`, {
      params: {
        healthPatientServiceId: params.healthPatientServiceId,
        initialDateTime: params.initialDateTime,
        finalDateTime: params.finalDateTime,
        serviceEnded: params.serviceEnded,
        offset,
        pageSize
      },
      validateStatus: () => true
    });

    return {
      status: response.status,
      data: response.data
    };
  }

  function exportValuationOfPatientReport(params: { filterDTO: FilterDTO, multiSortMeta: any, healthPatientServiceId: number, initialDateTime: Date, finalDateTime: Date, serviceEnded: boolean | null }, columns: ColumnDTO[]) {
    const exportConfigDTO: ExportConfigDTO = {
      loadConfigDTO: {
        offset: 0,
        pageSize: 0,
        sortingFieldInfoList: params.multiSortMeta,
        filters: params.filterDTO
      },
      columns
    };
    return exportFile(`${baseEndpoint}/exportValuationOfPatientReport`, exportConfigDTO, { healthPatientServiceId: params.healthPatientServiceId, initialDateTime: params.initialDateTime, finalDateTime: params.finalDateTime, serviceEnded: params.serviceEnded });
  }

  async function getValuationOfPatientComplete(offset: number, pageSize: number, params: any) {
    const response = await api.get(`${baseEndpoint}/getValuationOfPatientComplete`, {
      params: {
        healthPatientServiceId: params.healthPatientServiceId,
        initialDateTime: params.initialDateTime ? toLocalISOString(params.initialDateTime) : undefined,
        finalDateTime: params.finalDateTime ? toLocalISOString(params.finalDateTime) : undefined,
        serviceEnded: params.serviceEnded,
        offset,
        pageSize
      },
      validateStatus: () => true
    });

    return {
      status: response.status,
      data: response.data
    };
  }

  function exportValuationOfPatientCompleteReport(params: { filterDTO: FilterDTO, multiSortMeta: any, healthPatientServiceId: number, initialDateTime: Date, finalDateTime: Date, serviceEnded: boolean | null }, columns: ColumnDTO[]) {
    const exportConfigDTO: ExportConfigDTO = {
      loadConfigDTO: {
        offset: 0,
        pageSize: 0,
        sortingFieldInfoList: params.multiSortMeta,
        filters: params.filterDTO
      },
      columns
    };
    return exportFile(`${baseEndpoint}/exportValuationOfPatientCompleteReport`, exportConfigDTO, { healthPatientServiceId: params.healthPatientServiceId, initialDateTime: params.initialDateTime, finalDateTime: params.finalDateTime, serviceEnded: params.serviceEnded });
  }

  return {
    getValuationOfPatient,
    exportValuationOfPatientReport,
    getValuationOfPatientComplete,
    exportValuationOfPatientCompleteReport
  };
}
